import {AppState} from "../store";

export const getExceedsNonPrimaryVolumeStatisticsSearchPageFilter = (state: AppState) => state.exceedsNonPrimaryVolumeStatisticsSearchPage.filter
